import React, { PropsWithChildren } from 'react';
import { Outlet } from 'react-router';

function Dashboard({ children }: PropsWithChildren<{}>) {
    return (
        <React.Fragment>
            <div className="flex h-screen w-screen flex-col bg-[#ececec] p-5">
                <Outlet />
            </div>
        </React.Fragment>
    );
}

export default Dashboard;
